import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-bir-supplier-select-item',
  templateUrl: './bir-supplier-item.component.html',
  styles: [],
  standalone: false
})
export class BirSupplierItemSelectItemComponent {
  @Input() bir: any = {};

  get name() {
    if (this.bir) {
      if (this.bir.classification === 2) {
        return [this.bir.lastName, this.bir.firstName, this.bir.middleName]
          .filter(x => x)
          .join(', ');
      }
      return this.bir?.companyName;
    }
    return '';
  }
  get tin() {
    return `${this.bir.tinNumber} - (${this.bir.tinBranchCode})`;
  }
  constructor() {}
}
